function UserComponent($http, AppConstants) {
	'ngInject';

	const service = {
		'fetchUsers': fetchUsers,
		'getUsers': getUsers,
		'clearUsers': clearUsers,
		'changePassword': changePassword
	};

	let users = [];

	return service;

	function fetchUsers(userName) {
		const params = {
			'params': {
				'query': userName
			}
		};

		return $http.get(`${ AppConstants.apiUrl }/users`, params)
			.then(setUsers)
			.catch(failedRequest);
	}

	function changePassword(userId, params) {
		return $http.put(`${AppConstants.apiUrl}/users/${userId}`, params)
			.then(successRequest)
			.catch(failedRequest);
	}

	function getUsers() {
		return users;
	}

	function setUsers(data) {
		users = data.data.data;
		return users;
	}

	function successRequest(response) {
		return response;
	}

	function failedRequest(requestError) {
		return requestError;
	}

	function clearUsers() {
		users = [];
		return users;
	}
}
export default UserComponent;




/** WEBPACK FOOTER **
 ** ./client/components/user/user.service.js
 **/